import React, { useEffect, useState } from 'react';
import { Skeleton, Empty } from 'antd';
import api from '../../../services/api';
import TeamNewsPanel from '../../../components/community/TeamNewsPanel';

// Wrapper: reusa TeamNewsPanel dentro do admin.futezap.com.br.
// Descobre o community_team.id do time ativo do organizador via customer_id.
// Reaproveita 100% a UI ja usada no TeamOwnerDashboard do comunidade.
export default function AdminCommunityMural() {
  const [teamId, setTeamId] = useState(null);
  const [currentCpId, setCurrentCpId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Puxa perfil do time via /community/teams/profile (organizador → usa admin token)
    api.get('/community/teams/profile')
      .then(r => setTeamId(r.data?.id || null))
      .catch(() => setTeamId(null))
      .finally(() => setLoading(false));
    // owner_player_id do time = community_player id do organizador. Usado
    // pra saber se pode deletar propria noticia.
    api.get('/community/team-owner/my')
      .then(r => {
        const t = (r.data?.teams || [])[0];
        if (t?.owner_player_id) setCurrentCpId(t.owner_player_id);
      }).catch(() => {});
  }, []);

  if (loading) return <div style={{ padding: 40 }}><Skeleton active /></div>;
  if (!teamId) return <Empty description="Perfil de time não encontrado" style={{ padding: 60 }} />;
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 16 }}>
      <TeamNewsPanel teamId={teamId} isOwner={true} currentPlayerId={currentCpId} />
    </div>
  );
}
